import React from 'react'
import { ReactComponent as EyeIcon } from '../../assets/icons/table/eye.svg'
import { ReactComponent as EditIcon } from '../../assets/icons/table/edit.svg'
import { ReactComponent as BagIcon } from '../../assets/icons/table/bag-cross.svg'
import { ReactComponent as CopyIcon } from '../../assets/icons/table/copy-success.svg'
import { ReactComponent as ReceiptIcon } from '../../assets/icons/table/receipt-edit.svg'
import { ReactComponent as SmsSearch } from '../../assets/icons/table/sms-search.svg'
import { ReactComponent as SendIcon } from '../../assets/icons/table/send-2@2x.svg'
// import Print from '../../assets/icons/table/printer.svg'
import { Box, IconButton, styled, SxProps } from '@mui/material'
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';

import SaveAsIcon from '@mui/icons-material/SaveAs';
import UndoIcon from '@mui/icons-material/Undo';
import { colors } from '../../constants/colors'

type Props = {
    enableView?: boolean;
    enableEdit?: boolean;
    enableDelete?: boolean;
    enableCopy?: boolean;
    enableCancel?: boolean;
    enableDownload?: boolean;
    enableSave?: boolean;
    enableResolution?: boolean;
    enableExamination?: boolean;
    enableSend?: boolean;
    // enablePrint?: boolean;
    onCopy?: () => void;
    onViewClick?: (e?: any) => void;
    onEditClick?: (e?: any) => void;
    onDeleteClick?: (e?: any) => void;
    onCancelClick?: () => void;
    onSaveClick?: () => void;
    onDownloadClick?: () => void;
    onResolutionClick?: () => void;
    onExaminationClick?: () => void;
    onSendClick?: () => void;
    // onPrintClick?: () => void;
    disabledDownload?: boolean;
    disabledView?: boolean;
    disabledEdit?: boolean;
    disabledDelete?: boolean;
    disabledCopy?: boolean;
    disabledCancel?: boolean;
    disabledSave?: boolean;
    disabledResolution?: boolean;
    disabledExamination?: boolean;
    disabledSend?: boolean;
    
    // disabledPrint?: boolean;
    sx?: SxProps;
}
const IconButtonCustomStyle = styled(IconButton)({
    '&:disabled': {
        opacity: .4
    }
})

const OptionsButtonCustom: React.FC<Props> = ({
    enableDelete,
    enableEdit,
    enableView,
    onEditClick,
    onDeleteClick,
    onViewClick,
    enableCopy,
    onCopy,
    onCancelClick,
    onSaveClick,
    disabledCancel,
    disabledSave,
    enableCancel,
    enableSave,
    disabledCopy,
    disabledDelete,
    disabledEdit,
    disabledView,
    enableDownload,
    disabledDownload,
    onDownloadClick,
    // onStockClick,
    enableResolution,
    onResolutionClick,
    disabledResolution,
    enableExamination,
    disabledExamination,
    onExaminationClick,
    enableSend,
    disabledSend,
    onSendClick,
    sx
}: Props) => {
    return (
        <Box className={"flex flex-start items-center transition-all "}>
             {enableSend  && (
                <IconButtonCustomStyle sx={{ ...sx, color: colors.themeMainColor }} disabled={disabledSend} onClick={onSendClick}>
                    <SendIcon />
                </IconButtonCustomStyle>
            )}
             {enableExamination  && (
                <IconButtonCustomStyle sx={{ ...sx, color: colors.themeMainColor }} disabled={disabledExamination} onClick={onExaminationClick}>
                    <SmsSearch />
                </IconButtonCustomStyle>
            )}
            {enableView && (
                <IconButtonCustomStyle sx={sx} disabled={disabledView} onClick={onViewClick}>
                    <EyeIcon />
                </IconButtonCustomStyle>
            )}
            {enableCopy && (
                <IconButtonCustomStyle sx={sx} disabled={disabledCopy} onClick={onCopy}>
                    <CopyIcon />
                </IconButtonCustomStyle>
            )}
            {enableEdit && (
                <IconButtonCustomStyle sx={sx} disabled={disabledEdit} onClick={onEditClick}>
                    <EditIcon />
                </IconButtonCustomStyle>
            )}
            {enableDownload && (
                <IconButtonCustomStyle sx={sx} disabled={disabledDownload} onClick={onDownloadClick}>
                    <FileDownloadOutlinedIcon />
                </IconButtonCustomStyle>
            )}
            
            {enableCancel && (
                <IconButtonCustomStyle sx={{ ...sx, color: colors.black_60 }} disabled={disabledCancel} onClick={onCancelClick}>
                    <UndoIcon />
                </IconButtonCustomStyle>
            )}
            {enableSave && (
                <IconButtonCustomStyle sx={{ ...sx, color: colors.themeMainColor }} disabled={disabledSave} onClick={onSaveClick}>
                    <SaveAsIcon />
                </IconButtonCustomStyle>
            )}
            {enableResolution && (
                <IconButtonCustomStyle sx={{ ...sx, color: colors.themeMainColor }} disabled={disabledResolution} onClick={onResolutionClick}>
                    <ReceiptIcon />
                </IconButtonCustomStyle>
            )}
            {enableDelete && (
                <IconButtonCustomStyle sx={sx} disabled={disabledDelete} onClick={onDeleteClick}>
                    <BagIcon />
                </IconButtonCustomStyle>
            )}
          
            {/* {enablePrint && (
                <IconButtonCustomStyle sx={{ ...sx, color: colors.themeMainColor }} disabled={disabledPrint} onClick={onPrintClick}>
                    <Print />
                </IconButtonCustomStyle>
            )} */}
        </Box>
    )
}

export default OptionsButtonCustom